import { Box, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import QuestionFillIcon from "../../../../../media/images/icons/question-fill";
import ArrowDownSVG from "../../../../../media/images/icons/arrow-down";

interface Props {
  q?: string;
  a?: string;
}

export default function FaqCard(props: Props) {
  const { a, q } = props;
  const [open, setOpen] = useState(false);

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.palette.bgColor.blueGrey100,
        borderRadius: "16px",
      }}
    >
      <Box
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingX: 2,
          paddingY: 2,
        }}
      >
        <Box
          sx={{
            width: "80%",
            display: "flex",
            gap: "8px",
          }}
        >
          <QuestionFillIcon color={theme.palette.primary.main} />
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            {q}
          </Typography>
        </Box>
        <Box
          sx={{
            transform: open ? "rotate(0deg)" : "rotate(90deg)",
            transition: "200ms",
          }}
        >
          <ArrowDownSVG color={theme.palette.primary.main} />
        </Box>
      </Box>

      <Box
        sx={{
          // border: "1px solid gray",
          transition: "all 0.5s",
          maxHeight: open ? "400px" : 0,
          overflow: "hidden",
          px: 2,
          py: open ? 1 : 0,
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: a || "" }} />
        </Typography>
      </Box>
    </Box>
  );
}
